(function ($) {
  Drupal.behaviors.crossSellAddOnV1 = {
    attach: function (context) {
      const self = this;
      const $module = $('.js-cross-sell--wrapper', context);

      $module.each(function () {
        const $this = $(this);

        self.getDom($this);
        self.setEvents($this);
      });
    },

    getDom: function ($that) {
      $that.nodes = {};
      $that.nodes.$productsWrapper = $that.find('.js-cross-sell--addon-products');
      $that.nodes.$viewAllCtas = $that.find('.js-cross-sell--view-all');
    },

    setEvents: function ($that) {
      const self = this;

      $that.nodes.$viewAllCtas.once().on('click', function () {
        const $this = $(this);

        self.toggleProducts($this, $that);
      });
    },

    toggleProducts: function ($cta, $that) {
      const isExpended = $cta.attr('aria-expanded') === 'true';
      const $products = $that.nodes.$productsWrapper.filter('#' + $cta.attr('aria-controls'));

      $cta.attr('aria-expanded', (!isExpended).toString());
      $products.attr('aria-hidden', isExpended.toString());
    }
  };
})(jQuery);
